import { getCustomerIdFromToken } from '../../utils/getCustomerIdFromToken';
import { analytics } from '../../utils/analytics';
import { put } from '../apiService';

export interface UpdateMarketRequest {
  id: string;
  name: string;
  location: string;
  nickname: string;
  tablespace: string;
  taxid: string;
  pronunciation: string;
  pacPhone?: string | null;
  resource: Record<string, string | Record<string, string>>;
  active: boolean;
  external: boolean;
}

export interface UpdateMarketResponse {
  status: string;
  marketId: string;
}

export const updateMarket = async (
  body: UpdateMarketRequest
): Promise<{
  data: UpdateMarketResponse;
  loading: boolean;
}> => {
  const customer = getCustomerIdFromToken();
  if (!customer) {
    throw new Error('Customer Id is not available');
  }

  const url = `/resourceMatrix/market/update?customerId=${customer}`;
  let loading = true;
  try {
    const responseData = await put(
      url,
      body as unknown as Record<string, unknown>,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
    loading = false;
    analytics.trackEvent('update', 'market');
    return { data: responseData as UpdateMarketResponse, loading };
  } catch (error) {
    loading = false;
    throw new Error('Failed to update market');
  }
};
